export enum VariantTypes {
  Color = 'Color',
  General = 'general',
  Default = 'Title'
}

export const DefaultVariantTitle = 'Default Title';